import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=5ecd3adf&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"
import style0 from "./Certification.vue?vue&type=style&index=0&id=5ecd3adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd3adf",
  null
  
)

export default component.exports